// Create new file: src/pages/ForgotPasswordPage.jsx

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';

const ForgotPasswordPage = () => {
  return (
    <Box sx={{ py: 8, minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" color="primary" sx={{ fontWeight: 700, mb: 2 }}>
            XAUPilot
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Smart Trading Signals, Delivered Instantly
          </Typography>
        </Box>
        
        <ForgotPasswordForm />
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;

